import { Avatar, Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import Cookies from 'js-cookie';
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom';

function PackageSingleTeacher({ teacher }) {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const lang = Cookies.get("i18next") || "en";

    return (
        <Paper sx={{ padding: "32px 24px", marginY: "30px" }}>
            <Typography sx={{ fontSize: "22px", marginBottom: "18px" }}>
                {t('packages')}
            </Typography>

            <Box sx={{ display: "flex", flexWrap: "wrap", gap: "16px", justifyContent: "center" }}>
                <TableContainer component={Paper} sx={{ maxWidth: '100%' }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell align="center" sx={{ display: { xs: 'none', md: 'table-cell' } }}>{t('Photo')}</TableCell>
                                <TableCell align="center">{t('title')}</TableCell>
                                <TableCell align="center" sx={{ display: { xs: 'none', md: 'table-cell' } }}>{t('description')}</TableCell>
                                <TableCell align="center">{t('actions')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {teacher ? (
                                teacher.map((row, index) => (
                                    <TableRow key={row.id || index}>
                                        <TableCell align="center" sx={{ display: { xs: 'none', md: 'table-cell' } }}>
                                            <Avatar
                                                src={`${process.env.REACT_APP_API_KEY}images/${row?.image}`}
                                                sx={{ width: "80px", height: "80px" }}
                                            />
                                        </TableCell>
                                        <TableCell align="center">
                                            {lang === "ar" ? row.titleAr || t("No Title") : row.titleEn || t("No Title")}
                                        </TableCell>
                                        <TableCell align="center" sx={{display: { xs: 'none', md: 'table-cell' }, maxWidth: "200px", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}>
                                            {lang === "ar" ? row.descriptionAr || t("No Description") : row.descriptionEn || t("No Description")}
                                        </TableCell>
                                        <TableCell align="center">
                                            <Button size="small" color="primary" onClick={() => navigate(`./${row.id}`)}>
                                                {t("View more")}
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={4} align="center">
                                        <Typography
                                            sx={{
                                                fontSize: "16px",
                                                margin: "5px",
                                                padding: "10px",
                                                background: "#f8f9f9",
                                                textAlign: "center",
                                            }}
                                        >
                                            {t('There are no special Packages.')}
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Paper>
    );
}

export default PackageSingleTeacher;
